"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const access_control_list_service_1 = require("./access-control-list.service");
const access_control_list_controller_1 = require("./access-control-list.controller");
const typeorm_1 = require("@nestjs/typeorm");
const user_role_entity_1 = require("../../../../service-lib/src/lib/entities/user-role.entity");
const acl_actions_entity_1 = require("../../../../service-lib/src/lib/entities/acl-actions.entity");
const acl_categories_entity_1 = require("../../../../service-lib/src/lib/entities/acl-categories.entity");
const acl_category_action_map_entity_1 = require("../../../../service-lib/src/lib/entities/acl-category-action-map.entity");
const role_acl_category_action_map_entity_1 = require("../../../../service-lib/src/lib/entities/role-acl-category-action-map.entity");
const config_1 = require("@nestjs/config");
const access_control_list_repository_1 = require("./access-control-list.repository");
let AccessControlModule = class AccessControlModule {
};
exports.AccessControlModule = AccessControlModule;
exports.AccessControlModule = AccessControlModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                user_role_entity_1.UserRole,
                acl_actions_entity_1.AclAction,
                acl_categories_entity_1.AclCategory,
                acl_category_action_map_entity_1.AclCategoryActionMap,
                role_acl_category_action_map_entity_1.RoleAclCategoryActionMap,
            ]),
            config_1.ConfigModule,
        ],
        providers: [access_control_list_service_1.AccessControlListService, access_control_list_repository_1.AccessControlListRepository],
        controllers: [access_control_list_controller_1.AccessControlListController],
    })
], AccessControlModule);
